jQuery3_4_1(document).ready(function($){
    class Residencycard {
        constructor(parent) {
            const self = this;
            if(parent.residencycard){
                return;
            }
            parent.residencycard = self;
            self.console = new DD_Console();
            self.parent = $(parent);
            self.awake();
            setTimeout(function(){
                self.start();
            },0);
        }

        awake(){
            const self = this;
            self.console.verbose("AWAKE: Residencycard", self);
            self.registerSplide();
        }

        start(){
            const self = this;
            self.console.verbose("START: Residencycard", self);
            self.registerSplidePaginationButtons()
        }

        registerSplide(){
            const self = this;
			self.parent.find(".splide:not(.is-initialized)").each(function(index, element){
				element.splide = new Splide(element , {
					type   		: 'slide',
                    arrows      : false,
					pagination	: true,
					perMove     : 1,
					perPage     : 1,
				}).mount();
			})
        }

        registerSplidePaginationButtons(){
            const self = this;
            self.parent.find(".splide__pagination__page").on("click", function(event){
                if(DDPlatform.device.isMouseEvent(event)){
                    event.stopPropagation();
                }
            })
        }
    }
    registerOnLoadEvent(function(){
        $(".dd-residencycard").each(function(){
            new Residencycard(this);
        })
    });

});